// extracted by mini-css-extract-plugin
export default {"container":"_1xkeM96N","moduleColor":"_2aMxqegs","hidden":"oN55kyfF","palette":"_3hyMc-T9","isClosed":"B1zGKLt8","option":"XJjq95ha btn","selected":"_3HvMTTjO"};